import React from 'react';
import PropTypes from 'prop-types';
import {DragSource} from 'react-dnd';
import {getEmptyImage} from 'react-dnd-html5-backend';
import classNames from 'classnames';
import styles from './TransferableSelectItem.scss';
import ItemPropType from './ItemPropType.js';
import TransferableSelectItemTemplate from './TransferableSelectItemTemplate.jsx';

const spec = {
  beginDrag: ({item, targetedItems}, monitor, component) => {
    let boundingRect = component.ref.getBoundingClientRect();

    let items = targetedItems;

    if (!targetedItems.includes(item)) {
      items = [item];
    }

    return {
      items,
      dimensions: {
        width: boundingRect.width,
        height: boundingRect.height
      }
    };
  },
  isDragging: ({item}, monitor) => {
    let monitorItem = monitor.getItem();
    return monitorItem && monitorItem.items.includes(item);
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

class TransferableSelectItem extends React.Component {

  componentDidMount = () => {
    this.props.connectDragPreview(getEmptyImage());
  }

  handleClick = (event) => {
    let {
      item,
      onClick,
      onShiftClick,
      onCtrlClick
    } = this.props;

    if (!event.shiftKey && !event.ctrlKey) {
      onClick(item);
    }
    else if (event.shiftKey) {
      onShiftClick(item);
    }
    else if (event.ctrlKey) {
      onCtrlClick(item);
    }
  }

  render() {
    let {
      item,
      targetedItems,
      isDragging,
      connectDragSource,
    } = this.props;

    let isTargeted = targetedItems.includes(item);
    return connectDragSource(
      <div ref={ref => this.ref = ref} onClick={this.handleClick}>
        <TransferableSelectItemTemplate item={item} className={classNames(isDragging ? styles.dragging : '', isTargeted ? styles.targeted : '')} />
      </div>
    );
  }
}

TransferableSelectItem.propTypes = {
  item: ItemPropType.isRequired,
  type: PropTypes.string.isRequired,
  targetedItems: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  onShiftClick: PropTypes.func.isRequired,
  onCtrlClick: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,

};

export default DragSource(({type}) => type, spec, collect)(TransferableSelectItem);